var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticStyle:{"color":"#7a7157","text-decoration":"none","white-space":"nowrap"},attrs:{"href":_vm.$host + _vm.href}},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }